<script lang="ts" setup>import { ref as _ref } from 'vue';

import { useCart } from '@consumer/services/order'
import { openModal } from '@consumer/services/modals'
import AddedToCartModal from '@consumer/modals/AddedToCartModal.vue'
import { useEventListener } from '@vueuse/core'
import CartMenuDesktop from './CartMenuDesktop.vue'
import CartMenuMobile from './CartMenuMobile.vue'

const cart = useCart()

let unloading = _ref(false)

useEventListener('beforeunload', () => unloading.value = true)

watchEffect(
  () => {
    if (cart.lastAddedGift) {
      // We need this timeout to let the inertia:navigate event propagate (which closes all modals).
      // Otherwise, the modal will be opened and immediately closed.
      setTimeout(() => {
        if (!unloading.value) openModal(AddedToCartModal, { id: 'added-to-cart-modal' })
      }, 200)
    }
  },
)

</script>

<template>
  <div class="flex items-center h-full">
    <CartMenuDesktop class="hidden lg:flex"/>
    <CartMenuMobile class="lg:hidden"/>
  </div>
</template>
